import React from "react";

import Gate from "components/Gate";

import "./Preloader.css";

/**
 * Display a placeholder while loading
 * Sepcifically styled for the Home Page
 */
export default class Preloader extends React.Component {
  
  render() {
    
    const { isLoading, children } = this.props;
    
    const placeholder = (
      <div className="home-section-placeholder">
        Loading...
      </div>
    )
    
    return (
      <Gate isOpen={!isLoading} placeholder={placeholder}>
        { children }
      </Gate>
    )
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/app/home/Preloader.js